/**
 * NativeWaves Identity API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class ExternalApi extends runtime.BaseAPI {
    /**
     * Authenticated Azure Active Directory login
     */
    async tenantsTenantExternalAzureAdNativewavesLoginPostRaw(requestParameters, initOverrides) {
        if (requestParameters.tenant === null ||
            requestParameters.tenant === undefined) {
            throw new runtime.RequiredError('tenant', 'Required parameter requestParameters.tenant was null or undefined when calling tenantsTenantExternalAzureAdNativewavesLoginPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/tenants/{tenant}/external/azure/ad/nativewaves/login`.replace(`{${'tenant'}}`, String(requestParameters.tenant)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Authenticated Azure Active Directory login
     */
    async tenantsTenantExternalAzureAdNativewavesLoginPost(requestParameters, initOverrides) {
        const response = await this.tenantsTenantExternalAzureAdNativewavesLoginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Authenticated Azure Active Directory login to nativewavescloud
     */
    async tenantsTenantExternalAzureAdNativewavescloudLoginPostRaw(requestParameters, initOverrides) {
        if (requestParameters.tenant === null ||
            requestParameters.tenant === undefined) {
            throw new runtime.RequiredError('tenant', 'Required parameter requestParameters.tenant was null or undefined when calling tenantsTenantExternalAzureAdNativewavescloudLoginPost.');
        }
        if (requestParameters.aDB2CLoginRequest === null ||
            requestParameters.aDB2CLoginRequest === undefined) {
            throw new runtime.RequiredError('aDB2CLoginRequest', 'Required parameter requestParameters.aDB2CLoginRequest was null or undefined when calling tenantsTenantExternalAzureAdNativewavescloudLoginPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/tenants/{tenant}/external/azure/ad/nativewavescloud/login`.replace(`{${'tenant'}}`, String(requestParameters.tenant)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.aDB2CLoginRequest,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Authenticated Azure Active Directory login to nativewavescloud
     */
    async tenantsTenantExternalAzureAdNativewavescloudLoginPost(requestParameters, initOverrides) {
        const response = await this.tenantsTenantExternalAzureAdNativewavescloudLoginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const TenantsTenantExternalAzureAdNativewavesLoginPostTenantEnum = {
    System: 'system',
    Nativewaves: 'nativewaves',
    Showcase: 'showcase',
    Externalapp: 'externalapp',
};
/**
 * @export
 */
export const TenantsTenantExternalAzureAdNativewavescloudLoginPostTenantEnum = {
    System: 'system',
    Nativewaves: 'nativewaves',
    Showcase: 'showcase',
    Externalapp: 'externalapp',
};
//# sourceMappingURL=ExternalApi.js.map